import { RouteForTitel } from "@/entities/tvv";
import { Collapsible, CollapsibleContent, CollapsibleTrigger, Icon } from "@/shared/components/ui";
import { cn } from "@/shared/utils";
import type { ReactNode } from "react";
import { useState } from "react";
import { RouteTags } from "./route-tags";
import { RouteTitel } from "./route-titel";

type TvvRouteItemBaseProps = {
    route: RouteForTitel;
    defaultOpen?: boolean;
    summaryText: string;
    children: ReactNode;
};

export function TvvRouteItemBase({ route, defaultOpen = false, summaryText, children }: Readonly<TvvRouteItemBaseProps>) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <li>
            <Collapsible open={isOpen} onOpenChange={setIsOpen} className="border-t" data-testid={`route-${route.stationCodes.join(">")}`}>
                <CollapsibleTrigger className="flex w-full items-center justify-between py-4">
                    <RouteTitel route={route} className="font-medium" />
                    <div className="flex items-center gap-2">
                        {!isOpen && (
                            <span className="text-content-subtle text-m" data-testid="route-status">
                                {summaryText}
                            </span>
                        )}
                        <Icon name="chevron-down" size="m" className={cn("transition-transform", isOpen && "rotate-180")} />
                    </div>
                </CollapsibleTrigger>

                <CollapsibleContent>
                    <div className="space-y-4 pt-2 pb-4">
                        <RouteTags
                            organisatie={route.organisatie}
                            voertuigSoort={route.voertuigSoort}
                            ovLijnNummer={route.ovLijnNummer}
                            totaleRijtijd={route.totaleRijtijd}
                            busFrequentie={route.busFrequentiePerUur}
                        />
                        {children}
                    </div>
                </CollapsibleContent>
            </Collapsible>
        </li>
    );
}
